import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import groupageService from "./groupageService";

const initialState = {
  groupages: [],
  groupage: {},
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

// Get groupages
export const getGroupages = createAsyncThunk(
  "groupages/get",
  async (query, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await groupageService.getGroupages(query, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Get groupage
export const getGroupage = createAsyncThunk(
  "groupages/getOne",
  async (id, thunkAPI) => {
    try {
      return await groupageService.getGroupage(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Create groupages
export const createGroupage = createAsyncThunk(
  "groupages/create",
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await groupageService.createGroupage(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Update groupage
export const updateGroupage = createAsyncThunk(
  "groupages/update",
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await groupageService.updateGroupage(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// delete groupage
export const deleteGroupage = createAsyncThunk(
  "groupages/delete",
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await groupageService.deleteGroupage(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Add Shipment To Groupage
export const addShipmentToGroupage = createAsyncThunk(
  "groupages/shipments/add",
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await groupageService.addShipmentToGroupage(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Bulk Add Shipment To Groupage
export const bulkAddShipmentToGroupage = createAsyncThunk(
  "groupages/shipments/bulkAdd",
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await groupageService.bulkAddShipmentToGroupage(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// Remove Shipments from Groupage
export const removeShipmentsFromGroupage = createAsyncThunk(
  "groupages/shipments/remove",
  async (data, thunkAPI) => {
    try {
      const token = thunkAPI.getState().auth.user.token;
      return await groupageService.removeShipmentsFromGroupage(data, token);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const groupageSlice = createSlice({
  name: "groupages",
  initialState,
  reducers: {
    reset: (state) => {
      state.groupages = [];
      state.groupage = {};
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGroupages.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(getGroupages.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.groupages = action.payload;
        state.message = "";
      })
      .addCase(getGroupages.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.groupages = [];
      })
      .addCase(getGroupage.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(getGroupage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.groupage = action.payload;
        if (state.groupages.length > 0) {
          const groupageIndex = state.groupages.findIndex(
            (obj) => obj.id === action.payload.id
          );
          state.groupages[groupageIndex] = {
            ...action.payload,
          };
        }
        state.message = "";
      })
      .addCase(getGroupage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.groupages = [];
      })
      .addCase(createGroupage.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(createGroupage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;

        state.groupages.unshift(action.payload);
        state.message = "";
      })
      .addCase(createGroupage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(updateGroupage.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(updateGroupage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        if (state.groupages.length > 0) {
          const groupageIndex = state.groupages.findIndex(
            (obj) => obj.id === action.payload.id
          );
          state.groupages[groupageIndex] = {
            ...state.groupages[groupageIndex],
            ...action.payload,
          };
        }
        state.message = "";
      })
      .addCase(updateGroupage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(addShipmentToGroupage.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(addShipmentToGroupage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        if (
          state.groupages.length > 0 &&
          action.payload.groupage &&
          action.payload.shipment
        ) {
          const groupageIndex = state.groupages.findIndex(
            (obj) => obj.id === action.payload.groupage.id
          );
          const shipments = state.groupages[groupageIndex].Shipments;
          if (shipments) {
            state.groupages[groupageIndex] = {
              ...state.groupages[groupageIndex],
              Shipments: [...shipments, action.payload.shipment],
            };
          } else {
            state.groupages[groupageIndex] = {
              ...state.groupages[groupageIndex],
              Shipments: [action.payload.shipment],
            };
          }
        }
        state.message = "";
      })
      .addCase(addShipmentToGroupage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(bulkAddShipmentToGroupage.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(bulkAddShipmentToGroupage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        if (
          state.groupages.length > 0 &&
          action.payload.groupage &&
          action.payload.shipment
        ) {
          const groupageIndex = state.groupages.findIndex(
            (obj) => obj.id === action.payload.groupage.id
          );
          state.groupages[groupageIndex] = action.payload;
        }
        state.message = "";
      })
      .addCase(bulkAddShipmentToGroupage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deleteGroupage.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(deleteGroupage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        if (state.groupages.length === 1) state.groupages = [];
        else {
          state.groupages = state.groupages.filter(
            (s) => s.id !== action.payload
          );
        }
        state.message = "";
      })
      .addCase(deleteGroupage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(removeShipmentsFromGroupage.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.isSuccess = false;
        state.message = "";
      })
      .addCase(removeShipmentsFromGroupage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        if (state.groupages.length > 0) {
          const groupageIndex = state.groupages.findIndex(
            (obj) => obj.id === action.payload.groupage_id
          );
          let shipments = [...state.groupages[groupageIndex].Shipments];
          shipments = shipments.filter(
            (shipment) => !action.payload.shipment_ids.includes(shipment.id)
          );
          state.groupages[groupageIndex] = {
            ...state.groupages[groupageIndex],
            Shipments: shipments,
          };
        }
        state.message = "";
      })
      .addCase(removeShipmentsFromGroupage.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { reset } = groupageSlice.actions;
export default groupageSlice.reducer;
